var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "industry-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t\t.shp0 { fill: #0678c1 } \r\n\t\t.shp1 { opacity: 0;fill: #000000 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M480 80L480 480L0 480L0 0L152 0L152 207.27L277.48 80L312 80L312 209.7L443.26 80L480 80ZM448 120.3L318.76 248L280 248L280 123.02L156.78 248L120 248L120 32L32 32L32 448L448 448L448 120.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M120 312L120 320L152 320L152 288L120 288L120 312Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M120 360L152 360L152 392L120 392L120 360Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M200 312L200 320L232 320L232 288L200 288L200 312Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M200 360L232 360L232 392L200 392L200 360Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M280 312L280 320L312 320L312 288L280 288L280 312Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M280 360L312 360L312 392L280 392L280 360Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M360 288L392 288L392 320L360 320L360 288Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M360 360L392 360L392 392L360 392L360 360Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M-16 -16L496 -16L496 496L-16 496L-16 -16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.f5370e0513ae4daecda736b2b2487758.svg";
export { ForwardRef as ReactComponent };